<script setup lang="ts">
const { data: page } = await useAsyncData(useRoute().path, () => queryCollection('content').path(useRoute().path).first())

const { data: posts } = await useAsyncData('partners', () => queryCollection('partners').all())

useSeoMeta({
  title: page.value.title,
  description: page.value.description,
})
</script>

<template>
  <UContainer>
    <UPageHeader
        v-bind="page.meta.hero"
        class="py-[50px]"
    />

    <UPageBody>
      <UBlogPosts>
        <UBlogPost
            v-for="(post, index) in posts"
            :key="index"
            :to="post.path"
            :title="post.title"
            :description="post.description"
            :image="`${post.path}.jpg`"
            orientation="vertical"
            :ui="{
              image: 'object-center',
              title: 'text-clip',
              description: 'line-clamp-2'
            }"
        />
      </UBlogPosts>
    </UPageBody>
  </UContainer>
  <SectionAbout />
</template>